/**
 * Spine (kernel-native: the kernel is the system of record; no coreBOS module yet).
 * Framework scoping facts about the organisation (1:1 with the CRM account): NIS2 applicability, GDPR role, size. Input to every overlay.
 * Hand-written (ADR-029 §4); links to other spines are graph edges, see src/spines.ts.
 */
export const organisationProfileDescriptor = {
    slug: 'cmp_organisation_profile',
    kind: 'document',
    label: { singular: 'Profilo organizzazione', plural: 'Profili organizzazione' },
    table: 'compliance_organisation_profile',
    idStrategy: 'sha256',
    fields: [
        { name: 'nis2_in_scope', type: 'boolean', label: 'Soggetto NIS2' },
        { name: 'nis2_entity_class', type: 'text', label: 'Classe NIS2' },
        { name: 'sector', type: 'text', label: 'Settore' },
        { name: 'employees_count', type: 'number', label: 'Numero dipendenti' },
        { name: 'gdpr_controller', type: 'boolean', label: 'Titolare del trattamento' },
        { name: 'dpo_designated', type: 'boolean', label: 'DPO designato' },
        // AI Act Art. 27 (FRIA) and GDPR Art. 37.1.a: bodies governed by public law, or private entities providing public services
        { name: 'public_body', type: 'boolean', label: 'Ente pubblico o servizio pubblico' },
    ],
    relations: [
        { name: 'organisation', kind: 'belongsTo', target: 'account', toEntitySpine: true },
        { name: 'dpo', kind: 'belongsTo', target: 'contact', toEntitySpine: true },
    ],
    behaviors: { audit: true, softDelete: true, tenantScoped: true },
    ui: { mode: 'generated', icon: 'BankOutlined', navGroup: 'Organizzazione' },
};
